module.exports = __webpack_public_path__ + "img/locomash_logo_main.b2193ae0.svg";